/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecuteAssetOcppCommandResponseDto
 */
export interface ExecuteAssetOcppCommandResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    action: ExecuteAssetOcppCommandResponseDtoActionEnum;
    /**
     * Present only for Reset.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    type?: ExecuteAssetOcppCommandResponseDtoTypeEnum;
    /**
     * OCPP acknowledgement. rejected, notSupported, and callError are completed charger answers, not transport failures.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    outcome: ExecuteAssetOcppCommandResponseDtoOutcomeEnum;
    /**
     * uniqueId of the EVIMO-originated CALL.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    uniqueId: string;
    /**
     * OCPP CALL payload that was sent to the charger.
     * @type {object}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    requestPayload: object;
    /**
     * OCPP CALLRESULT payload or CALLERROR details when available.
     * @type {object}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    responsePayload?: object;
    /**
     * Present for GetLocalListVersion when the charger returned listVersion.
     * @type {number}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    listVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    errorDescription?: string;
    /**
     * Present for GetDiagnostics. AssetDiagnostic id created before the OCPP CALL (also returned on timeout responses).
     * @type {string}
     * @memberof ExecuteAssetOcppCommandResponseDto
     */
    diagnosticId?: string;
}


/**
 * @export
 */
export const ExecuteAssetOcppCommandResponseDtoActionEnum = {
    Reset: 'Reset',
    ClearCache: 'ClearCache',
    GetLocalListVersion: 'GetLocalListVersion',
    GetConfiguration: 'GetConfiguration',
    TriggerMessage: 'TriggerMessage',
    ChangeConfiguration: 'ChangeConfiguration',
    GetDiagnostics: 'GetDiagnostics'
} as const;
export type ExecuteAssetOcppCommandResponseDtoActionEnum = typeof ExecuteAssetOcppCommandResponseDtoActionEnum[keyof typeof ExecuteAssetOcppCommandResponseDtoActionEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandResponseDtoTypeEnum = {
    Soft: 'Soft',
    Hard: 'Hard'
} as const;
export type ExecuteAssetOcppCommandResponseDtoTypeEnum = typeof ExecuteAssetOcppCommandResponseDtoTypeEnum[keyof typeof ExecuteAssetOcppCommandResponseDtoTypeEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandResponseDtoOutcomeEnum = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    NotSupported: 'notSupported',
    CallError: 'callError'
} as const;
export type ExecuteAssetOcppCommandResponseDtoOutcomeEnum = typeof ExecuteAssetOcppCommandResponseDtoOutcomeEnum[keyof typeof ExecuteAssetOcppCommandResponseDtoOutcomeEnum];


/**
 * Check if a given object implements the ExecuteAssetOcppCommandResponseDto interface.
 */
export function instanceOfExecuteAssetOcppCommandResponseDto(value: object): value is ExecuteAssetOcppCommandResponseDto {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('uniqueId' in value) || value['uniqueId'] === undefined) return false;
    if (!('requestPayload' in value) || value['requestPayload'] === undefined) return false;
    return true;
}

export function ExecuteAssetOcppCommandResponseDtoFromJSON(json: any): ExecuteAssetOcppCommandResponseDto {
    return ExecuteAssetOcppCommandResponseDtoFromJSONTyped(json, false);
}

export function ExecuteAssetOcppCommandResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteAssetOcppCommandResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'type': json['type'] == null ? undefined : json['type'],
        'outcome': json['outcome'],
        'uniqueId': json['uniqueId'],
        'requestPayload': json['requestPayload'],
        'responsePayload': json['responsePayload'] == null ? undefined : json['responsePayload'],
        'listVersion': json['listVersion'] == null ? undefined : json['listVersion'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorDescription': json['errorDescription'] == null ? undefined : json['errorDescription'],
        'diagnosticId': json['diagnosticId'] == null ? undefined : json['diagnosticId'],
    };
}

export function ExecuteAssetOcppCommandResponseDtoToJSON(json: any): ExecuteAssetOcppCommandResponseDto {
    return ExecuteAssetOcppCommandResponseDtoToJSONTyped(json, false);
}

export function ExecuteAssetOcppCommandResponseDtoToJSONTyped(value?: ExecuteAssetOcppCommandResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'type': value['type'],
        'outcome': value['outcome'],
        'uniqueId': value['uniqueId'],
        'requestPayload': value['requestPayload'],
        'responsePayload': value['responsePayload'],
        'listVersion': value['listVersion'],
        'errorCode': value['errorCode'],
        'errorDescription': value['errorDescription'],
        'diagnosticId': value['diagnosticId'],
    };
}

